import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LocationTypes } from '@shared/pipes/location.pipe';
import { ButtonColor } from '@widgets/eop-button/eop-button.component';
import { IconColor, IconSize } from '@widgets/eop-icon/eop-icon.component';
import { MODAL_DATA } from '@widgets/modal/modal.service';
import { ModalRef } from '@widgets/modal/modalRef';

export interface UnmuteStationModalConfig {
  stationName: string;
  country: string;
  zipCode: string;
  city: string;
  street: string;
}

@Component({
  selector: 'eop-unmute-station-alerts-modal',
  templateUrl: './unmute-station-alerts-modal.component.html',
  styleUrls: ['./unmute-station-alerts-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UnmuteStationAlertsModalComponent {
  modalData = inject<UnmuteStationModalConfig>(MODAL_DATA);

  protected readonly LocationTypes = LocationTypes;
  protected readonly ButtonColor = ButtonColor;
  protected readonly IconSize = IconSize;
  protected readonly IconColor = IconColor;

  private readonly modalRef: ModalRef = inject(ModalRef);

  onClose() {
    this.modalRef.close(false);
  }

  onConfirm(): void {
    this.modalRef.close(true);
  }
}
